import React, { useEffect, useState } from 'react';
import { /* Answer, Pagination, Publish, Question, */ ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './formCard.style.scss';
import Cover from 'assets/images/backgrounds/card-cover.jpg';
import { Link } from 'react-router-dom';
import { /* API, */ RoutePath } from 'data';
import { __FormCardProps } from './formCard.interface';
import FormCardSkeleton from './formCard.skeleton';
// import { offlineQuestionerSubmit } from 'ucheck/publishDetail/SLP/SLP.scripts';
// import { get, responseValidator } from 'scripts/api';
// import { downloadImages, objImgFind } from '../forms.scripts';
import { getPublishAnswersCount } from 'scripts/db';
// import { toast } from 'react-toastify';

const PublishCard: React.FC<ConnectedProps<typeof connector> & __FormCardProps> = function (
    props: ConnectedProps<typeof connector> & __FormCardProps,
) {
    const [answersCount, setAnswerCount] = useState<number | undefined>(0);
    const lang = props.language.wsPanel.panel.forms.card;

    useEffect(() => {
        getPublishAnswersCount(props.data.id).then((res) => {
            setAnswerCount(res);
        });
    }, []);

    return (
        <div
            className="ucheck-kiosk-form-card"
            onClick={() => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }}
        >
            <Link to={RoutePath.dashboard.publishDetail(props.data.id, props.data.form.id)}>
                {props.data.form.background_image_file || !props.data.form.background_color ? (
                    <img
                        src={props.data.form.background_image_file ? props.data.form.background_image_file.file : Cover}
                        alt="Form image"
                    />
                ) : (
                    <span style={{ backgroundColor: props.data.form.background_color }} className="form-color-cover" />
                )}
                <div className="details">
                    <div className="d-flex align-items-center justify-content-between">
                        <h6>{props.data.form.title}</h6>
                        <i className={`material-icons`}>{false ? 'notifications' : ''}</i>
                    </div>
                    <div className="items">
                        <i className="material-icons">content_copy</i>
                        <span>{answersCount}</span>
                        <p>{lang.answersCount}</p>
                    </div>
                    <div className="items">
                        <i className="material-icons">schedule</i>
                        <p>{lang.lastActivity}</p>
                        <span>{new Date(props.data.created_at).toLocaleDateString('fa')}</span>
                    </div>
                </div>
                {props.data.complete_answers === 0 && <div className="new-label">{lang.new}</div>}
            </Link>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    userData: state.userData,
    language: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(PublishCard);
